import React, { lazy } from 'react';
import {
  BASE_URL,
  ADMIN_URL,
  NOT_FOUND_URL,
  PRICE_URL,
  FAQ_INSTALL_URL,
  ADMIN_USERS_URL,
  //ADMIN_USER_BILLS_URL,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL,
  TERMS_CONDITIONS_URL,
  RESET_PASS_REJECT_URL,
  RESET_PASS_CONFIRM_URL,
  ADMIN_USER_SETTINGS_URL,
  ADMIN_USER_PASSWORD_URL,
  ADMIN_USER_REFERRAL_URL,
  ADMIN_USER_BRIEFS_URL,
  ADMIN_MANAGEMENT_SETTINGS_URL,
  ADOBE_RATING_URL,
  ADMIN_ADOBE_RATING_URL,
  ACTIVATED_SUCCESS_URL,
  KEYMAKER_URL,
  GET_PLUGIN_URL,
  REFERRAL_URL,
} from './routes.constants';

import FooterProvider from '@app/providers/footer';

const HomePage = lazy(() => import('@pages/home'));
//const LoginPage = lazy(() => import('@pages/login'));
const Price = lazy(() => import('@pages/price'));
const Faq = lazy(() => import('@pages/faq'));
const Users = lazy(() => import('@pages/admin/users'));
//const MyBills = lazy(() => import('@pages/admin/my_bills'));
//const ReturnPolicy = lazy(() => import('@pages/return_policy'));
const CookiePolicy = lazy(() => import('@pages/cookie_policy'));
const PrivacyPolicy = lazy(() => import('@pages/privacy_policy'));
const ResetPassPage = lazy(() => import('@pages/password/reset'));
const AdminSettings = lazy(() => import('@pages/admin/settings'));
const TermsConditions = lazy(() => import('@pages/terms_conditions'));
const PersonalSettings = lazy(() => import('@pages/admin/personal_settings'));
const PersonalPassword = lazy(() => import('@pages/admin/personal_password'));
const PersonalReferral = lazy(() => import('@pages/admin/personal_referral'));
const MyBriefs = lazy(() => import('@pages/admin/my_briefs'));
const GetPlugin  = lazy(() => import('@pages/plugin'));
const EmailActivated = lazy(() => import('@pages/email_activated'));
const KeyMaker = lazy(() => import('@pages/key-maker'));
const Referral = lazy(() => import('@pages/referral'));
const AdobeRating = lazy(() => import('@pages/adobe_rating'));

const NotFoundPage = lazy(() => import('@pages/404'));

export const STATIC_ROUTES = [
  {
    path: BASE_URL,
    element: (
      <FooterProvider>
        <HomePage />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: KEYMAKER_URL,
    element: <KeyMaker />,
    sitemapIndex: true,
    exact: true,
  },
  {
    path: PRICE_URL,
    element: (
      <FooterProvider>
        <Price />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: REFERRAL_URL,
    element: (
      <FooterProvider>
        <Referral />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: FAQ_INSTALL_URL,
    element: (
      <FooterProvider>
        <Faq />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: PRIVACY_POLICY_URL,
    element: (
      <FooterProvider>
        <PrivacyPolicy />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: TERMS_CONDITIONS_URL,
    element: (
      <FooterProvider>
        <TermsConditions />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  /*{
    path: RETURN_POLICY_URL,
    element: (
      <FooterProvider>
        <ReturnPolicy />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  {
    path: COOKIE_POLICY_URL,
    element: (
      <FooterProvider>
        <CookiePolicy />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: NOT_FOUND_URL,
    element: (
      <FooterProvider>
        <NotFoundPage />
      </FooterProvider>
    ),
    sitemapIndex: true,
  },
  {
    path: RESET_PASS_CONFIRM_URL,
    element: <ResetPassPage />,
    sitemapIndex: true,
  },
  {
    path: RESET_PASS_REJECT_URL,
    element: <ResetPassPage />, // RejectPassPage
    sitemapIndex: true,
  },
  {
    path: ACTIVATED_SUCCESS_URL,
    element: <EmailActivated />,
    sitemapIndex: true,
  },
  {
    path: GET_PLUGIN_URL,
    element: (
      <FooterProvider>
        <GetPlugin />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  // Публичная витрина. Эндпоинт /adobe/get-rating личность не определяет ВООБЩЕ и всегда
  // отдаёт сокращённый список, поэтому ProtectedRoute тут не нужен. Полная выдача живёт на
  // ADMIN_ADOBE_RATING_URL (см. ADMIN_ROUTES) и ходит в /adobe/get-rating-full за авторизацией.
  {
    path: ADOBE_RATING_URL,
    element: (
      <FooterProvider>
        <AdobeRating />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
];

export const AUTH_ROUTES = [
  {
    path: ADMIN_URL,
    element: <></>,
    sitemapIndex: true,
    internalsRouts: [
      {
        path: ADMIN_URL,
        element: <NotFoundPage />,
        sitemapIndex: true,
      },
      {
        path: NOT_FOUND_URL,
        element: <NotFoundPage />,
        sitemapIndex: true,
      },
    ],
  },
];


// admin/ for all users
export const ADMIN_ROUTES = [
  {
    path: ADMIN_USER_SETTINGS_URL,
    element: (
      <FooterProvider>
        <PersonalSettings />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ADMIN_USER_PASSWORD_URL,
    element: (
      <FooterProvider>
        <PersonalPassword />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ADMIN_USER_REFERRAL_URL,
    element: (
      <FooterProvider>
        <PersonalReferral />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ADMIN_USER_BRIEFS_URL,
    element: (
      <FooterProvider>
        <MyBriefs />
      </FooterProvider>),
    sitemapIndex: true,
    exact: true,
  },
  {
    // Полная выдача рейтингов. Та же страница, что и публичная витрина, но роут лежит в
    // ADMIN_ROUTES — то есть для гостя оборачивается в ProtectedRoute и уводит на логин.
    path: ADMIN_ADOBE_RATING_URL,
    element: (
      <FooterProvider>
        <AdobeRating />
      </FooterProvider>),
    sitemapIndex: true,
    exact: true,
  },
];

// admin/ for admins & executors
export const EXECUTOR_ROUTES = [
  {
    path: ADMIN_USERS_URL,
    element: <Users />,
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ADMIN_MANAGEMENT_SETTINGS_URL,
    element: <AdminSettings />,
    sitemapIndex: true,
    exact: true,
  },
];

// admin/ for users
export const USERS_ROUTES = [
  /*{
    path: ADMIN_USER_PROJECTS_URL,
    element: <ProjectsUser />,
    sitemapIndex: true,
    exact: true,
  },*/
];
